module.exports = __webpack_public_path__ + "static/ebrands-55bdd98122666b304255e98b4a25cef2.jpg";